import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import React from 'react';

import { Block as Component } from '../block';
import type { IDeps, IProps, TBlock } from '../models';
import styles from '../styles/desktop.css';
import { paddedTypesDesktop } from '../config';

const Widget = createWidget<IDeps, TBlock>({ styles }, { priorityStyler: true })(Component);

export const BlockDesktop = ({
    borderRadius,
    inner,
    notPadded,
    paddedType = 'standard',
    styler,
    ...rest
}: IProps) => {
    const customStyler: IStyler = notPadded ? {} : paddedTypesDesktop[paddedType];

    if (typeof borderRadius !== 'undefined' && borderRadius !== false) {
        customStyler.borderRadius = borderRadius === true ? 4 : borderRadius;
    }

    if (inner) {
        customStyler.borderRadius = 4;
        customStyler.paddingLeft = 0;
        customStyler.paddingRight = 0;
        customStyler.paddingTop = 24;
        customStyler.paddingBottom = 24;
    }

    if (typeof styler?.padding === 'number') {
        const { padding } = styler;

        customStyler.paddingTop = padding;
        customStyler.paddingBottom = padding;
        customStyler.paddingLeft = padding;
        customStyler.paddingRight = padding;
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Widget styler={{ ...customStyler, ...styler }} {...rest} />;
};
